module.exports = __webpack_public_path__ + "static/media/knee-extension.c72aefda.svg";